export default __webpack_public_path__ + "static/media/bitter-gourd.f19242d4.jpg";